import Photos from "./Photos"; 

function Gallery() {
    return(
        <div className="full-view">
            <Photos/>
        </div>
    ); 
}

export default Gallery; 